/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Multilingual } from '../../../../ts/assistant';
import { saveAs } from '../../util/download';

// Multilingual status for enablement, exoprt and import
export const enum MultilingualStatusType {
  PROCESSING = 'Processing',
  COMPLETED = 'Completed',
  FAILED = 'Failed'
}

export const enum DownloadUploadType {
  ASSISTANT_ONLY = 'assistantOnly',
  MULTILINGUAL_FILE_PACKAGE = 'multilingualFilePackage'
}

export const enum TabType {
  DOWNLOAD = 'download',
  UPLOAD = 'upload'
}

export const isProcessing = (multilingual: Multilingual): boolean =>
  multilingual?.status === MultilingualStatusType.PROCESSING;

export const isFailed = (multilingual: Multilingual): boolean =>
  multilingual?.status === MultilingualStatusType.FAILED;

/**
 * Provide a `data` object and trigger a save as by calling `saveAs()`
 * @param {Object} data The data object
 * @param {string} fileName file name
 *
 * @returns {undefined}
 */
export const triggerSaveZip = (data: any, fileName: string) => {
  const dataAsBlob = new Blob([data], {
    type: 'application/zip'
  });
  const url = URL.createObjectURL(dataAsBlob);
  saveAs(url, fileName);
};
